import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box, Button } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import {
    canSearch,
    currentPage,
    groups,
    hasSearched,
    isLoadingFilters,
    selectedBrands,
    selectedMarkets,
    selectedSites,
    submittedFilters,
    totalCount
} from "../@signals"


export default function SkuDuplicatesFiltersFooter() {
    const handleSearch = () => batch(() => {
        currentPage.value = 0
        isLoadingFilters.value = true
    })

    const handleClear = () => batch(() => {
        selectedMarkets.value = []
        selectedSites.value = []
        selectedBrands.value = []
        groups.value = []
        totalCount.value = 0
        currentPage.value = 0
        hasSearched.value = false
        submittedFilters.value = null
    })

    return (
        <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
                variant="outlined"
                size="small"
                onClick={handleClear}
                disabled={isLoadingFilters.value}
            >
                Clear
            </Button>
            <Button
                variant="contained"
                size="small"
                onClick={handleSearch}
                disabled={!canSearch.value || isLoadingFilters.value}
                startIcon={isLoadingFilters.value ? <IconSeeker icon="spinner" spin="true" /> : <IconSeeker icon="search" />}
            >
                Search
            </Button>
        </Box>
    )
}
